import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  static values = {
    requestLocationAlert: String,
    calculatingPosition: String,
    couldNotCalculatePosition: String,
    geolocationNotSupported: String,
  };

  connect() {
    if (!new URLSearchParams(document.location.search).get('rbf_claim_template_id')) {
      this.check();
    }
  }

  clear() {
    if (!this.hasInputTarget) return;

    this.inputTarget.value = '';
    this.inputTarget.placeholder = '';
  }

  check() {
    if (!this.hasInputTarget) return;

    const gpsLocationField = this.inputTarget;
    gpsLocationField.value = '';

    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      if (permissionStatus.state === 'prompt' && window.railsEnv !== 'test') {
        alert(this.requestLocationAlertValue);
      }
      gpsLocationField.placeholder = this.calculatingPositionValue;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            gpsLocationField.placeholder = '';
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            gpsLocationField.value = `${latitude},${longitude}`;
          },
          (error) => {
            gpsLocationField.placeholder = this.couldNotCalculatePositionValue;
            console.warn(`ERROR(${error.code}): ${error.message}`);
          }
        );
      } else {
        gpsLocationField.placeholder = this.geolocationNotSupportedValue;
        console.error(this.geolocationNotSupportedValue);
      }
    });
  }
}
